import angular from 'angular'

import unparkRun from './unpark.run'
import unparkRoutes from './unpark.routes'
import unparkCtrl from './unpark.controller'

const name = 'routingManeuverUnpark'

angular.module(name, [

])
  .controller('unparkCtrl', unparkCtrl)
  .run(unparkRun)
  .config(unparkRoutes)

export default name



// WEBPACK FOOTER //
// ./public/javascript/sygem/routing/maneuver/unpark/unpark.module.js